import { InjectionToken, Type } from '@angular/core';

/**
 * An optional component an app renders in the header, right before the
 * notification bell — the place for a brand's always-visible action, such as
 * Global Health's "Need help? — Support" entry. Provided per app in
 * `app.config.ts`; when absent the header is unchanged.
 */
export const HEADER_ACTION_COMPONENT = new InjectionToken<Type<unknown>>('HEADER_ACTION_COMPONENT');
